export const departmentTableWidths = {
  DEPARTMENTS: 338,
  CATEGORIES:338,
  SUBCATEGORIES:338,
  TYPES:337,
  SUBTYPES:337,
  ACTIONS:120,
}